let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bUP8i")).then(() => parcelRequire('hwSqh'));